import { Button, Popover } from '@mui/material';
import { useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import Styles from '../css/LoanInformation.module.css';

type PopoverProps = {
  text: string;
};

const PopoverInfo = (props: PopoverProps) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  return (
    <>
      <button
        onClick={(e) => {
          setOpen(!open);
          setAnchorEl(e.target);
        }}
        className={Styles.popoverbutton}
      >
        <InfoIcon fontSize={'small'}></InfoIcon>
      </button>
      <Popover
        anchorEl={anchorEl}
        open={open}
        onClose={(e) => setOpen(false)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <p className={Styles.popover}>{props.text}</p>
      </Popover>
    </>
  );
};

export default PopoverInfo;
